"use client";

import { InvitationsPageContainer } from "@/app/(discover)/candidate/invites/(tabs)/invitations/components/invitations-page";
import DormantSeasonPanel from "@/app/(discover)/candidate/invites/components/dormant-season/dormant-season-panel.container";
import InvitesTabsLayout from "@/app/(discover)/candidate/invites/components/invites-tabs-layout";
import { withAuthGate } from "@/components/shared/auth-paywall/with-auth-gate";
import { authTestIds } from "@/lib/data-test-ids/components.data-test-ids";
import { isHiringSeasonDormant } from "@/lib/dormant-season/resolve";
import type { User } from "@/lib/types/auth";

function InvitationsTabPageContent({ user: user }: { user: User }) {
  return (
    <InvitesTabsLayout>
      {isHiringSeasonDormant("invitations") ? (
        <DormantSeasonPanel surface="invitations" className="h-full" />
      ) : (
        <InvitationsPageContainer user={user} />
      )}
    </InvitesTabsLayout>
  );
}

export default withAuthGate(InvitationsTabPageContent, {
  testId: authTestIds.SIGN_IN_INVITES_TAB,
});
